import InvalidLoginImage from "@assets/images/invalid_login.svg";
import { LockClosedIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

const InvalidLoginPage: React.FC = () => {
  return (
    <div className="absolute top-0 left-0 h-screen w-screen flex justify-center items-center flex-col ">
      <img src={InvalidLoginImage} width={400} height={400} alt="" />
      <p className="text-gray-700 text-lg font-semibold ">Oops ! We can't find page you're looking for</p>
      <p className="text-gray-600">You need to login to access this page.</p>
      <Link
        to={"/app/login"}
        className="rounded-md bg-white mt-4 px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 flex justify-center items-center"
      >
        <LockClosedIcon/>
        <span className="ml-2">Login</span>
      </Link>
    </div>
  );
};

export default InvalidLoginPage;
